export default {
    portfolios(state) {
        return state.portfolios
    },
    getPortfolio: (state) => (id) => {
        return state.portfolios.find(
            (portfolio) => portfolio.id == id
        )
    },
}